"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoCodeApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class PromoCodeApi extends runtime.BaseAPI {
    /**
     * This endpoint will return the initial rate plan for an enrollment.
     * Returns the initial rate plan.
     */
    async getInitialRatePlanRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling getInitialRatePlan.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling getInitialRatePlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/enrollment/{enrollmentId}/initialRatePlan`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.InitialRatePlanResponseFromJSON(jsonValue));
    }
    /**
     * This endpoint will return the initial rate plan for an enrollment.
     * Returns the initial rate plan.
     */
    async getInitialRatePlan(requestParameters) {
        const response = await this.getInitialRatePlanRaw(requestParameters);
        return await response.value();
    }
    /**
     * This endpoint will validate the supplied promo code is valid and unused.
     * Validate the supplied promo code is valid and unused.
     */
    async validatePromoCodeRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling validatePromoCode.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling validatePromoCode.');
        }
        if (requestParameters.validatePromoCodeRequest === null || requestParameters.validatePromoCodeRequest === undefined) {
            throw new runtime.RequiredError('validatePromoCodeRequest', 'Required parameter requestParameters.validatePromoCodeRequest was null or undefined when calling validatePromoCode.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/enrollment/{enrollmentId}/promo/validate`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ValidatePromoCodeRequestToJSON(requestParameters.validatePromoCodeRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ValidatePromoCodeResponseFromJSON(jsonValue));
    }
    /**
     * This endpoint will validate the supplied promo code is valid and unused.
     * Validate the supplied promo code is valid and unused.
     */
    async validatePromoCode(requestParameters) {
        const response = await this.validatePromoCodeRaw(requestParameters);
        return await response.value();
    }
}
exports.PromoCodeApi = PromoCodeApi;
//# sourceMappingURL=PromoCodeApi.js.map